CCL.carousel = {
  autoload: [
    ['carousel2', $('.owl-carousel-2').length > 0],
    ['carousel3', $('.owl-carousel-3').length > 0],
    ['carousel4', $('.owl-carousel-4').length > 0],
    ['carousel5', $('.owl-carousel-5').length > 0],
    ['carousel6', $('.owl-carousel-6').length > 0],
    ['carouselcruise', $('.owl-carousel-cruise').length > 0],
    ['carousel1', $('.owl-carousel').length > 0],
    ['bulletsContext', $('.owl-theme').length > 0],
    ['carousel6Navigation', $('.owl-carousel-6').length > 0],
    ['carousel3_4Navigation', $('body').length > 0],
    ['carouselNavigation', $('.owl-carousel').length > 0],
    ['carouselCruiseNavigation', $('.owl-carousel-cruise').length > 0]
  ],

  carousel2() {
    $('.owl-carousel-2').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 2
        },
        1200: {
          items: 2
        }
      }
    });
  },

  carousel3() {
    $('.owl-carousel-3').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 3
        },
        1200: {
          items: 3
        }
      }
    });
  },

  carousel4() {
    $('.owl-carousel-4').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 3
        },
        1200: {
          items: 4
        }
      }
    });
  },

  carousel5() {
    $('.owl-carousel-5').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 3
        },
        1200: {
          items: 5
        }
      }
    });
  },

  carousel6() {
    $('.owl-carousel-6').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 2
        },
        768: {
          items: 3
        },
        1024: {
          items: 4
        },
        1200: {
          items: 6
        }
      }
    });
  },

  carouselcruise() {
    $('.owl-carousel-cruise').owlCarousel({
      loop: false,
      nav: true,
      margin: 0,
      touchDrag: true,
      mouseDrag: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      items: 1,
      onInitialized: CCL.carousel.counterLoad,
      onTranslate: CCL.carousel.counter
    });
  },

  carousel1() {
    $('.owl-carousel').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      items: 1
    });
  },

  counterLoad(event) {
    $('.owl-carousel-cruise .owl-nav').prepend('<span class="counter"></span>');
    $('.owl-carousel-cruise .owl-nav').prepend('<span class="counter-hidden ccl-srOnly"></span>');
    CCL.carousel.counter(event);
  },

  counter(event) {
    const element = event.target;
    const items = event.item.count;
    let item = event.item.index + 1;

    if (item > items) {
      item -= items;
    }
    $('.owl-carousel-cruise .owl-nav .counter-hidden').removeAttr('role', 'alert');
    $('.owl-carousel-cruise .owl-nav .counter-hidden').text(`Current Slide ${item} of ${items}`);
    $('.owl-carousel-cruise .owl-nav .counter').text(`${item} of ${items}`);
    $('.owl-carousel-cruise .owl-nav .counter').removeAttr('tabindex').removeAttr('data-tabindex');
    $('.owl-carousel-cruise .owl-nav .counter-hidden').removeAttr('tabindex').removeAttr('data-tabindex');

    setTimeout(() => {
      $('.owl-carousel-cruise .owl-nav .counter-hidden').attr('role', 'alert');
    }, 200);
  },

  calculatePageBullet(dots) {
    const items = dots.find('.owl-dot');
    const n = items.length;

    if (n > 0) {
      items.each((index2, i) => {
        const bullet = $(i);
        let current = '';
        if (bullet.hasClass('active')) {
          current = '- Current page';
        }
        bullet.attr('aria-label', `Slide ${index2 + 1} of ${n} ${current}`);
      });
    }
  },
  bulletsContext() {
    setTimeout(() => {
      $('.owl-dots').each((index, e) => {
        const dots = $(e);
        this.calculatePageBullet(dots);
      });
    }, 400);

    // On next item click
    $('.owl-dots button').click((e) => {
      const currentTarget = $(e.currentTarget);
      setTimeout(() => {
        this.calculatePageBullet(currentTarget.parent());
      }, 200);
    });
  },

  // Get focusable elements given a parent carousel
  getFocusable(carousel, pos) {
    const tabbables = '[href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button:not([disabled]):not([style*="display:none"]):not(.owl-next):not(.owl-prev):not(.owl-dot):not(.disabled)';
    const items = carousel.find('> .owl-stage-outer > .owl-stage > .owl-item.active');
    const firstFocusable = items.find(tabbables).first();
    const lastFocusable = items.find(tabbables).last();
    return (pos === 'last') ? lastFocusable : firstFocusable;
  },

  getLastFocusable(carousel, pos) {
    const tabbables = '[href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button:not([disabled]):not([style*="display:none"]):not(.owl-next):not(.owl-prev):not(.owl-dot):not(.disabled)';
    const items = carousel.find('> .owl-stage-outer > .owl-stage > .owl-item.active').last();
    const firstFocusable = items.find(tabbables).first();
    const lastFocusable = items.find(tabbables).last();
    return (pos === 'last') ? lastFocusable : firstFocusable;
  },

  // Carousel 6 Navigation
  navigationBackwards(prevItem, selElement, carouselTop) {
    if (prevItem.length > 0) {
      selElement.attr('tabindex', '-1').attr('data-tabindex', '-1').removeClass('active');
      prevItem.find('.c-category-card a').addClass('active ada-element-focus').focus();
      carouselTop.find('.c-category-card a.active').attr('tabindex', '0').attr('data-tabindex', '0');
    }
    setTimeout(() => {
      if (carouselTop.find('.owl-item').first().hasClass('active')) {
        carouselTop.find('.owl-prev').addClass('disabled').attr('tabindex', '-1').attr('data-tabindex', '-1');
        carouselTop.find('.owl-prev').attr('aria-disabled', 'true');
      }
    }, 200);
  },
  navigationForward(nextItem, selElement, carouselTop) {
    if (nextItem.length > 0) {
      selElement.attr('tabindex', '-1').attr('data-tabindex', '-1').removeClass('active');
      nextItem.find('.c-category-card a').addClass('active ada-element-focus').focus();
      carouselTop.find('.c-category-card a.active').attr('tabindex', '0').attr('data-tabindex', '0');
    }
    if (carouselTop.find('.owl-item').first().not('active')) {
      carouselTop.find('.owl-prev').removeClass('disabled').attr('tabindex', '0').attr('data-tabindex', '0');
      carouselTop.find('.owl-prev').attr('aria-disabled', 'false');
    }
  },
  carousel6Navigation() {
    const carouselTop = $('.owl-carousel-6');
    const selElement = carouselTop.find('.c-category-card a');

    // Arrow Order
    const clonedObj = carouselTop.find('.owl-nav').clone();
    clonedObj.prependTo(carouselTop);

    // Arrow Purge
    carouselTop.find('.owl-nav button.owl-next').first().remove();
    carouselTop.find('.owl-nav button.owl-prev').last().remove();

    setTimeout(() => {
      selElement.attr('tabindex', '-1').attr('data-tabindex', '-1').removeClass('active');
      selElement.first().attr('tabindex', '0').attr('data-tabindex', '0').addClass('active');
    }, 50);

    carouselTop.keydown((e) => {
      const nextItem = carouselTop.find('.c-category-card a.active').parent().parent().next();
      const prevItem = carouselTop.find('.c-category-card a.active').parent().parent().prev();

      if (e.keyCode === 37 || e.keyCode === 38) {
        e.preventDefault();
        this.navigationBackwards(prevItem, selElement, carouselTop);
      } else if (e.keyCode === 39 || e.keyCode === 40) {
        e.preventDefault();
        this.navigationForward(nextItem, selElement, carouselTop);
      }
    });

    // On next item click
    carouselTop.find('.owl-next').click((e) => {
      e.preventDefault();
      const nextItem = carouselTop.find('.c-category-card a.active').parent().parent().next();
      this.navigationForward(nextItem, selElement, carouselTop);
    });
    // On previous item click
    carouselTop.find('.owl-prev').click((e) => {
      e.preventDefault();
      carouselTop.trigger('prev.owl.carousel');
      const prevItem = carouselTop.find('.c-category-card a.active').parent().parent().prev();
      this.navigationBackwards(prevItem, selElement, carouselTop);
    });
  },

  // .owl-carousel-4 .owl-carousel-3
  navigationBackwards_3_4(carouselTop) {
    this.enableButtons(carouselTop);
    setTimeout(() => {
      if (carouselTop.find('.owl-stage .owl-item:first').hasClass('active')) {
        carouselTop.find('> .owl-nav .owl-prev').addClass('disabled').attr('tabindex', '-1').attr('data-tabindex', '-1');
        carouselTop.find('.owl-prev').attr('aria-disabled', 'true');
      }
    }, 200);
  },
  navigationForward_3_4(carouselTop) {
    this.enableButtons(carouselTop);
    setTimeout(() => {
      if (!carouselTop.find('.owl-stage .owl-item:first').hasClass('active')) {
        carouselTop.find('> .owl-nav .owl-prev').removeClass('disabled').attr('tabindex', '0').attr('data-tabindex', '0');
        carouselTop.find('.owl-prev').attr('aria-disabled', 'false');
      }
    }, 200);
  },
  enableButtons(carouselTop) {
    carouselTop.find('.owl-dot').attr('tabindex', '-1').attr('data-tabindex', '-1');
    carouselTop.find('.owl-stage .owl-item').find('.general-add-to-cart-btn').attr('tabindex', '-1').attr('data-tabindex', '-1');
    carouselTop.find('.owl-stage .owl-item').find('.btn-more-details').attr('tabindex', '-1').attr('data-tabindex', '-1');
    carouselTop.find('.owl-stage .owl-item').find('.title a').attr('tabindex', '-1').attr('data-tabindex', '-1');
    carouselTop.find('.owl-stage .owl-item').find('.be-first-to-review').attr('tabindex', '-1').attr('data-tabindex', '-1');
    carouselTop.find('.owl-stage .owl-item.active').find('.general-add-to-cart-btn').attr('tabindex', '0').attr('data-tabindex', '0');
    carouselTop.find('.owl-stage .owl-item.active').find('.btn-more-details').attr('tabindex', '0').attr('data-tabindex', '0');
    carouselTop.find('.owl-stage .owl-item.active').find('.title a').attr('tabindex', '0').attr('data-tabindex', '0');
    carouselTop.find('.owl-stage .owl-item.active').find('.be-first-to-review').attr('tabindex', '0').attr('data-tabindex', '0');
  },
  carousel3_4Navigation() {
    setTimeout(() => {
      $('body .owl-carousel-3, body .owl-carousel-4, body .owl-carousel-2').each((index, e) => {
        const carouselTop = $(e);
        this.enableButtons(carouselTop);
        if (carouselTop.find('> .owl-nav').length < 2) {
          const clonedObj = carouselTop.find('> .owl-nav').clone();
          clonedObj.prependTo(carouselTop);
          carouselTop.find('> .owl-nav button.owl-next').first().remove();
          carouselTop.find('> .owl-nav button.owl-prev').last().remove();
          carouselTop.find('.c-product-card .owl-nav').remove();
          //  carouselTop.find('.c-product-card .owl-dots').remove();
        }

        carouselTop.keydown((event) => {
          if (event.keyCode === 37 || event.keyCode === 38) {
            this.navigationBackwards_3_4(carouselTop);
          } else if (event.keyCode === 39 || event.keyCode === 40) {
            this.navigationForward_3_4(carouselTop);
          } else if (event.keyCode === 9 && event.shiftKey) {
            this.navigationBackwards_3_4(carouselTop);
          } else if (event.keyCode === 9 && !event.shiftKey) {
            this.navigationForward_3_4(carouselTop);
          }
        });

        // On next item click
        carouselTop.find('.owl-next').click((event) => {
          this.navigationForward_3_4(carouselTop);
          setTimeout(() => {
            this.getLastFocusable(carouselTop).focus();
          }, 200);
        });
        // On previous item click
        carouselTop.find('.owl-prev').click((event) => {
          this.navigationBackwards_3_4(carouselTop);
          carouselTop.trigger('prev.owl.carousel');
          this.getFocusable(carouselTop).focus();
        });
      });
      $('body .owl-carousel-3 .owl-item:nth-child(4)').removeClass('active');
    }, 1000);
  },

  // .owl-carousel
  enablingSlideButtons(carouselTop) {
    setTimeout(() => {
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item').find('.ccl_product_title').attr('tabindex', '-1').attr('data-tabindex', '-1');
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item').find('.general-add-to-cart-btn').attr('tabindex', '-1').attr('data-tabindex', '-1');
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item').find('.btn-more-details').attr('tabindex', '-1').attr('data-tabindex', '-1');
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item').find('.be-first-to-review').attr('tabindex', '-1').attr('data-tabindex', '-1');
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item').find('.general-rating-product-card').attr('tabindex', '-1').attr('data-tabindex', '-1');
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item.active').find('.ccl_product_title').attr('tabindex', '0').attr('data-tabindex', '0');
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item.active').find('.general-add-to-cart-btn').attr('tabindex', '0').attr('data-tabindex', '0');
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item.active').find('.btn-more-details').attr('tabindex', '0').attr('data-tabindex', '0');
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item.active').find('.be-first-to-review').attr('tabindex', '0').attr('data-tabindex', '0');
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item.active').find('.general-rating-product-card').attr('tabindex', '0').attr('data-tabindex', '0');
    }, 300);

    if (carouselTop.find('> .owl-stage-outer .owl-stage .owl-item').length > 0) {
      if (carouselTop.find('> .owl-stage-outer .owl-stage .owl-item').first().not('active')) {
        carouselTop.find('.owl-prev').removeClass('disabled').attr('tabindex', '0').attr('data-tabindex', '0');
        carouselTop.find('.owl-prev').attr('aria-disabled', 'false');
      }
      if (carouselTop.find('> .owl-stage-outer .owl-stage .owl-item').first().hasClass('active')) {
        carouselTop.find('.owl-prev').addClass('disabled').attr('tabindex', '-1').attr('data-tabindex', '-1');
        carouselTop.find('.owl-prev').attr('aria-disabled', 'true');
      }
    }
  },

  carouselNavigation() {
    setTimeout(() => {
      $('.product-carousel-container.owl-carousel, .cruise-carousel-container.owl-carousel').each((index, e) => {
        const carouselTop = $(e);

        // Arrow Order
        const clonedObj = carouselTop.find('.owl-nav').eq(index).clone();
        clonedObj.prependTo(carouselTop);

        // Arrow Purge
        carouselTop.find('.owl-nav button.owl-next').first().remove();
        carouselTop.find('.owl-nav button.owl-prev').last().remove();
        carouselTop.find('.c-product-card .owl-nav').remove();
        carouselTop.find('.c-product-card .owl-dots').remove();

        // this.enablingSlideButtons(carouselTop);

        // On next item click
        carouselTop.find('.owl-next').click((event) => {
          this.enablingSlideButtons(carouselTop);
          setTimeout(() => {
            this.getFocusable(carouselTop).focus();
          }, 300);
        });
        // On previous item click
        carouselTop.find('.owl-prev').click((event) => {
          carouselTop.trigger('prev.owl.carousel');
          this.enablingSlideButtons(carouselTop);
          setTimeout(() => {
            this.getFocusable(carouselTop).focus();
          }, 300);
        });
      });
    }, 700);
  },

  // Carousel Cruise Navigation
  setActiveElements(carouselTop) {
    carouselTop.find('.owl-item.active').find('.hero-banner-product-card-title a').attr('tabindex', '0').attr('data-tabindex', '0');
    carouselTop.find('.owl-item.active').find('.btn-redeem-gift-card').attr('tabindex', '0').attr('data-tabindex', '0');
    carouselTop.find('.owl-item.active').find('.footer a').attr('tabindex', '0').attr('data-tabindex', '0');
  },
  carouselCruiseNavigation() {
    const carouselTop = $('.owl-carousel-cruise');
    // On next item click
    carouselTop.find('.owl-next').click((event) => {
      setTimeout(() => {
        this.setActiveElements(carouselTop);
        this.getFocusable(carouselTop).focus();
      }, 100);
    });
    // On previous item click
    carouselTop.find('.owl-prev').click((event) => {
      setTimeout(() => {
        this.setActiveElements(carouselTop);
        this.getFocusable(carouselTop).focus();
      }, 100);
    });
  }
};



// WEBPACK FOOTER //
// ./src/js/carousel.js